import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JustificativaModalComponent } from './justificativa-modal.component';
import { SharedModule } from '../../shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [JustificativaModalComponent],
  imports: [
    CommonModule, SharedModule, ReactiveFormsModule
  ]
})
export class JustificativaModalModule { }
